import React, { useEffect, useState } from "react";
//#region  types
import { GraphConstants } from "utils/constants";
import { SalaryDeviationFormTypes } from "models/formTypes";
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { WintSuperkollAPIModelWintSalaryDeviations } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
//#region  components
import { useFilterContext, ViewPanel, Chart, Skeletons } from "components/common";
import CategorySelector from "../_partials/categorySelector";
import { useWintSalaryDeviationService } from "serviceHooks";
import { ErrorBoundary } from "components/error";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const DeviationVariationChart: React.FC = () => {
  const { reportToApiFilter, getValidDeviationCategoriesSelectionItems } = useWintSalaryDeviationService();
  const { filter: pageFilter } = useFilterContext<SalaryDeviationFormTypes.WintSalaryDeviationReportFilter>();
  const [chartFilter, setChartFilter] = useState<
    WintSuperkollAPIModelWintSalaryDeviations.DeviationReportFilter | undefined
  >(undefined);

  const baseFilter = (pageFilter ?? {}) as SalaryDeviationFormTypes.WintSalaryDeviationReportFilter;

  const onCategoryChange = (category: SelectionItem) => {
    const newFilter = { ...baseFilter, categoryTypes: [category] };
    const apiFilter = reportToApiFilter(newFilter);
    setChartFilter(apiFilter);
  };

  const availableCategories =
    pageFilter?.categoryTypes && pageFilter.categoryTypes.length > 0
      ? pageFilter.categoryTypes
      : getValidDeviationCategoriesSelectionItems();

  const selctedChartCategory = chartFilter?.deviationCategories?.[0];

  useEffect(() => {
    const selected =
      availableCategories.find((category) => category.id === selctedChartCategory) ?? availableCategories[0];
    const apiFilter = reportToApiFilter({ ...baseFilter, categoryTypes: [selected] });
    setChartFilter(apiFilter);
  }, [pageFilter]);

  const labelFormatter = (label?: string) => {
    return label ? label.substring(0, 3) : "";
  };

  const dataUnit =
    selctedChartCategory === WintSuperkollAPIModelWintSalaryDeviations.SalaryDeviationTypeCategory.Absence ||
    selctedChartCategory === WintSuperkollAPIModelWintSalaryDeviations.SalaryDeviationTypeCategory.WorkedHours
      ? "h"
      : GraphConstants.DefaultDataUnit;

  return (
    <ViewPanel
      title={
        <CategorySelector
          onCategoryChange={onCategoryChange}
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.VariationOverTime)}
          availableCategories={availableCategories}
          selectedCategory={chartFilter?.deviationCategories?.[0]}
        />
      }
      appearance="sm"
      gridSize="md"
      isCanvasContent
    >
      <ErrorBoundary>
        {chartFilter ? (
          <Chart
            chartAPIKey={GraphConstants.ChartKeys.WintSalaryDeviationVariationChart}
            labelFormatter={labelFormatter}
            filter={chartFilter}
            dataUnit={dataUnit}
          />
        ) : (
          <Skeletons.WidgetSkeleton />
        )}
      </ErrorBoundary>
    </ViewPanel>
  );
};

export default DeviationVariationChart;
